import React from "react";
import { Link } from "wouter";
import { useDocumentTitle } from "@/hooks/use-document-title";

export default function UnsubscribeSuccessPage() {
  useDocumentTitle("Unsubscribed");
  return (
    <div className="flex-1 flex items-center justify-center px-4 pt-24 pb-20">
      <div className="max-w-md w-full bg-zinc-900/50 border border-white/10 rounded-xl p-8 backdrop-blur text-center">
        <div
          className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-5"
          style={{ background: "rgba(16,185,129,0.08)", border: "1px solid rgba(16,185,129,0.2)" }}
        >
          <svg
            className="w-6 h-6"
            style={{ color: "#34d399" }}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-white uppercase tracking-tight mb-3">
          Unsubscribed
        </h1>
        <p className="text-zinc-400 font-sans text-sm leading-relaxed mb-6">
          You have been successfully unsubscribed from platform updates. You can manage your
          preferences at any time from your dashboard.
        </p>
        <Link
          href="/dashboard"
          className="inline-flex items-center justify-center h-10 px-6 bg-zinc-800 hover:bg-zinc-700 text-white text-sm font-bold uppercase tracking-wide rounded-lg border border-white/10 transition-colors"
        >
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
}
